(function () {
  var TIME_LABELS = {
    morning: "8:00 AM - 11:00 AM",
    afternoon: "11:00 AM - 2:00 PM",
    evening: "2:00 PM - 5:00 PM"
  };
  var MAX_FILES = 6;
  var MAX_FILE_SIZE = 50 * 1024 * 1024;
  var googleMapsPromise = null;

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return String(Date.now()) + "-" + Math.random().toString(16).slice(2);
  }

  function cleanText(value) {
    return String(value || "")
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function cleanMultiline(value) {
    return String(value || "")
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
      .replace(/\r\n?/g, "\n")
      .trim();
  }

  function normalizeEmail(value) {
    return cleanText(value).replace(/\s+/g, "").toLowerCase();
  }

  function normalizeZip(value) {
    return cleanText(value).replace(/[^0-9-]/g, "").slice(0, 10);
  }

  function formatPhone(value) {
    var digits = String(value || "").replace(/\D/g, "").slice(0, 10);
    if (!digits) return "";
    if (digits.length <= 3) return "(" + digits;
    if (digits.length <= 6) return "(" + digits.slice(0, 3) + ")-" + digits.slice(3);
    return "(" + digits.slice(0, 3) + ")-" + digits.slice(3, 6) + "-" + digits.slice(6);
  }

  function inferLocationFromPath() {
    var pathname = window.location.pathname.toLowerCase();
    if (pathname.indexOf("/pages/twin-falls-service") !== -1) return "Twin Falls";
    if (pathname.indexOf("/pages/boise-service") !== -1) return "Boise";
    if (pathname.indexOf("/pages/idaho-falls-service") !== -1) return "Idaho Falls";
    return "";
  }

  function loadGoogleMaps(apiKey) {
    if (!apiKey) return Promise.reject(new Error("Missing Google Maps API key"));

    if (
      window.google &&
      window.google.maps &&
      typeof window.google.maps.importLibrary === "function"
    ) {
      return Promise.resolve(window.google.maps);
    }

    if (googleMapsPromise) return googleMapsPromise;

    googleMapsPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector("script[data-lti-google-maps]");
      if (existing) {
        existing.addEventListener("load", function () {
          if (window.google && window.google.maps) resolve(window.google.maps);
          else reject(new Error("Google Maps failed to load"));
        });
        existing.addEventListener("error", function () {
          reject(new Error("Google Maps failed to load"));
        });
        return;
      }

      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(apiKey) +
        "&v=weekly&libraries=places";
      script.async = true;
      script.defer = true;
      script.dataset.ltiGoogleMaps = "true";
      script.onload = function () {
        if (window.google && window.google.maps) resolve(window.google.maps);
        else reject(new Error("Google Maps failed to load"));
      };
      script.onerror = function () {
        reject(new Error("Google Maps failed to load"));
      };
      document.head.appendChild(script);
    });

    return googleMapsPromise;
  }

  function stateToAbbreviation(value) {
    var normalized = cleanText(value).toLowerCase();
    if (normalized === "idaho" || normalized === "id") return "ID";
    if (normalized === "montana" || normalized === "mt") return "MT";
    if (normalized === "wyoming" || normalized === "wy") return "WY";
    return "";
  }

  function getAddressComponent(components, types, format) {
    var component = components.find(function (item) {
      return types.some(function (type) {
        return item.types && item.types.indexOf(type) !== -1;
      });
    });

    if (!component) return "";
    if (format === "short") return component.shortText || component.short_name || "";
    return component.longText || component.long_name || "";
  }

  function parseSelectedAddress(place) {
    var components = place.addressComponents || place.address_components || [];
    var streetNumber = getAddressComponent(components, ["street_number"], "long");
    var route = getAddressComponent(components, ["route"], "long");
    var city =
      getAddressComponent(components, ["locality"], "long") ||
      getAddressComponent(components, ["sublocality", "sublocality_level_1"], "long") ||
      getAddressComponent(components, ["postal_town"], "long");
    var state =
      getAddressComponent(components, ["administrative_area_level_1"], "short") ||
      getAddressComponent(components, ["administrative_area_level_1"], "long");
    var zip = getAddressComponent(components, ["postal_code"], "long");
    var formatted = place.formattedAddress || place.formatted_address || "";

    return {
      street: cleanText((streetNumber + " " + route).trim() || formatted.split(",")[0] || ""),
      city: cleanText(city),
      state: stateToAbbreviation(state),
      zip: cleanText(zip)
    };
  }

  function setFormValue(form, name, value) {
    var field = form.elements[name];
    if (!field || !value) return;
    field.value = value;
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setupAddressAutocomplete(root, form) {
    var apiKey = cleanText(root.dataset.googleMapsApiKey);
    var input = form.elements.customer_street_address;
    var suggestionsEl = root.querySelector("[data-address-suggestions]");
    if (!apiKey || !input || !suggestionsEl) return;

    var placesLibraryPromise = null;
    var sessionToken = null;
    var predictions = [];
    var activeIndex = -1;
    var requestId = 0;
    var timer = null;
    var suppressFetch = false;

    function hideSuggestions() {
      suggestionsEl.hidden = true;
      suggestionsEl.innerHTML = "";
      predictions = [];
      activeIndex = -1;
    }

    function renderSuggestions() {
      suggestionsEl.innerHTML = "";

      predictions.forEach(function (prediction, index) {
        var text = prediction.text || {};
        var mainText = text.mainText || {};
        var secondaryText = text.secondaryText || {};
        var button = document.createElement("button");
        var main = document.createElement("span");
        var secondary = document.createElement("span");

        button.type = "button";
        button.className = "lti-service-request__suggestion";
        button.dataset.active = index === activeIndex ? "true" : "false";
        main.className = "lti-service-request__suggestion-main";
        secondary.className = "lti-service-request__suggestion-secondary";
        main.textContent = mainText.text || text.text || "";
        secondary.textContent = secondaryText.text || "";

        button.appendChild(main);
        if (secondary.textContent) button.appendChild(secondary);
        button.addEventListener("mousedown", function (event) {
          event.preventDefault();
        });
        button.addEventListener("click", function () {
          selectPrediction(index);
        });
        suggestionsEl.appendChild(button);
      });

      suggestionsEl.hidden = predictions.length === 0;
    }

    function getPlacesLibrary() {
      if (!placesLibraryPromise) {
        placesLibraryPromise = loadGoogleMaps(apiKey).then(function (maps) {
          return maps.importLibrary("places");
        });
      }
      return placesLibraryPromise;
    }

    function ensureSessionToken(placesLibrary) {
      if (!sessionToken) {
        sessionToken = new placesLibrary.AutocompleteSessionToken();
      }
      return sessionToken;
    }

    function fetchSuggestions() {
      if (suppressFetch) {
        suppressFetch = false;
        return;
      }

      var value = cleanText(input.value);
      if (!value) {
        hideSuggestions();
        return;
      }

      var currentRequestId = ++requestId;
      getPlacesLibrary()
        .then(function (placesLibrary) {
          return placesLibrary.AutocompleteSuggestion.fetchAutocompleteSuggestions({
            input: value,
            includedRegionCodes: ["us"],
            region: "us",
            sessionToken: ensureSessionToken(placesLibrary)
          });
        })
        .then(function (response) {
          if (currentRequestId !== requestId) return;
          predictions = (response.suggestions || [])
            .map(function (suggestion) {
              return suggestion.placePrediction;
            })
            .filter(Boolean);
          activeIndex = predictions.length > 0 ? 0 : -1;
          renderSuggestions();
        })
        .catch(function () {
          if (currentRequestId === requestId) hideSuggestions();
        });
    }

    function scheduleFetch() {
      window.clearTimeout(timer);
      timer = window.setTimeout(fetchSuggestions, 300);
    }

    function selectPrediction(index) {
      var prediction = predictions[index];
      if (!prediction) return;

      suppressFetch = true;
      input.value = prediction.text && prediction.text.text ? prediction.text.text : input.value;
      hideSuggestions();

      getPlacesLibrary()
        .then(function () {
          var place = prediction.toPlace();
          return place.fetchFields({
            fields: ["addressComponents", "formattedAddress"]
          }).then(function () {
            return place;
          });
        })
        .then(function (place) {
          var parsed = parseSelectedAddress(place);
          setFormValue(form, "customer_street_address", parsed.street);
          setFormValue(form, "customer_city", parsed.city);
          setFormValue(form, "customer_state", parsed.state);
          setFormValue(form, "customer_zip", parsed.zip);
          sessionToken = null;
        })
        .catch(function () {
          sessionToken = null;
        });
    }

    input.addEventListener("input", scheduleFetch);
    input.addEventListener("focus", function () {
      if (cleanText(input.value)) scheduleFetch();
    });
    input.addEventListener("blur", function () {
      window.setTimeout(hideSuggestions, 150);
    });
    input.addEventListener("keydown", function (event) {
      if (suggestionsEl.hidden || predictions.length === 0) {
        if (event.key === "Escape") hideSuggestions();
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = (activeIndex + 1) % predictions.length;
        renderSuggestions();
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex = activeIndex <= 0 ? predictions.length - 1 : activeIndex - 1;
        renderSuggestions();
        return;
      }

      if (event.key === "Enter" && activeIndex >= 0) {
        event.preventDefault();
        selectPrediction(activeIndex);
        return;
      }

      if (event.key === "Escape") {
        hideSuggestions();
      }
    });
  }

  function isAllowedFile(file) {
    return file.type.indexOf("image/") === 0 ||
      file.type.indexOf("video/") === 0 ||
      file.type === "application/pdf";
  }

  function isDisallowedDate(value) {
    if (!value) return true;
    var selected = new Date(value + "T00:00:00");
    if (Number.isNaN(selected.getTime())) return true;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var day = selected.getDay();
    return selected <= today || day === 0 || day === 6;
  }

  function setStatus(root, message, tone) {
    var status = root.querySelector("[data-status]");
    if (!status) return;
    status.textContent = message;
    status.dataset.tone = tone;
    status.hidden = !message;
  }

  function clearResult(root) {
    var result = root.querySelector("[data-result]");
    var content = root.querySelector("[data-form-content]");
    if (result) {
      result.hidden = true;
      result.innerHTML = "";
      result.removeAttribute("data-tone");
    }
    if (content) content.hidden = false;
  }

  function scrollResultIntoView(result) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var offset = window.innerWidth <= 760 ? 84 : 110;
        var top = result.getBoundingClientRect().top + window.pageYOffset - offset;
        var behavior = window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth";

        window.scrollTo({
          top: Math.max(0, top),
          behavior: behavior
        });
        result.focus({ preventScroll: true });
      });
    });
  }

  function showResult(root, tone, title, message, actionLabel, onAction) {
    var result = root.querySelector("[data-result]");
    var content = root.querySelector("[data-form-content]");
    if (!result) return;

    result.innerHTML = "";
    result.dataset.tone = tone;

    var titleEl = document.createElement("div");
    titleEl.className = "lti-service-request__result-title";
    titleEl.textContent = title;

    var messageEl = document.createElement("div");
    messageEl.className = "lti-service-request__result-message";
    messageEl.textContent = message;

    result.appendChild(titleEl);
    result.appendChild(messageEl);

    if (actionLabel && typeof onAction === "function") {
      var action = document.createElement("button");
      action.type = "button";
      action.className = "lti-service-request__result-action";
      action.textContent = actionLabel;
      action.addEventListener("click", onAction);
      result.appendChild(action);
    }

    setStatus(root, "", "success");
    if (content) content.hidden = true;
    result.hidden = false;
    result.setAttribute("tabindex", "-1");
    scrollResultIntoView(result);
  }

  function formValue(form, name) {
    var field = form.elements[name];
    return field ? field.value : "";
  }

  function proxyUrl(root, path) {
    var base = root.dataset.proxyBase || "/apps/lti-service-requests";
    return base.replace(/\/+$/, "") + path;
  }

  function parseJsonResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var body = null;
      var statusMessage = response.status ? " HTTP " + response.status + " " + response.statusText + "." : "";
      if (text) {
        try {
          body = JSON.parse(text);
        } catch (error) {
          throw new Error(
            response.ok
              ? fallbackMessage
              : fallbackMessage + "." + statusMessage + " The server returned a non-JSON response."
          );
        }
      }

      if (!response.ok) {
        throw new Error((body && body.error) || fallbackMessage + "." + statusMessage);
      }

      return body || {};
    });
  }

  function fileTypeLabel(file) {
    var mimeType = cleanText(file.mime_type || file.type).toLowerCase();
    var fileName = cleanText(file.name);
    var extension = fileName.split(".").pop().toUpperCase();

    if (mimeType === "application/pdf") return "PDF";
    if (mimeType === "image/jpeg") return "JPG";
    if (mimeType === "image/png") return "PNG";
    if (mimeType === "image/heic") return "HEIC";
    if (mimeType === "image/webp") return "WEBP";
    if (mimeType === "video/mp4") return "MP4";
    if (mimeType === "video/quicktime") return "MOV";
    if (mimeType.indexOf("image/") === 0) return extension && extension !== fileName.toUpperCase() ? extension : "Image";
    if (mimeType.indexOf("video/") === 0) return extension && extension !== fileName.toUpperCase() ? extension : "Video";
    if (extension && extension !== fileName.toUpperCase()) return extension;
    return "File";
  }

  function renderFiles(root, files, onDelete) {
    var container = root.querySelector("[data-files]");
    if (!container) return;
    container.innerHTML = "";

    files.forEach(function (file) {
      var row = document.createElement("div");
      row.className = "lti-service-request__file";

      var name = document.createElement("div");
      name.className = "lti-service-request__file-name";
      name.textContent = file.name;
      name.title = file.name;

      var meta = document.createElement("div");
      meta.className = "lti-service-request__file-meta";
      meta.textContent = file.status === "uploading"
        ? "Uploading • " + file.size + " • " + fileTypeLabel(file)
        : file.size + " • " + fileTypeLabel(file);

      var remove = document.createElement("button");
      remove.type = "button";
      remove.textContent = "Remove";
      remove.addEventListener("click", function () {
        onDelete(file.path);
      });

      row.appendChild(name);
      row.appendChild(meta);
      row.appendChild(remove);
      container.appendChild(row);
    });
  }

  function init(root) {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    var form = root.querySelector("form");
    if (!form) return;

    var files = [];
    var draftId = uuid();
    form.elements.formStartedAt.value = String(Date.now());
    form.elements.draftId.value = draftId;
    root.dataset.compact = root.dataset.compact === "true" ? "true" : "false";

    var locationField = root.querySelector("[data-location-field]");
    var showLocation = root.dataset.showLocation !== "false";
    if (!showLocation && locationField) {
      locationField.hidden = true;
    }

    var inferredLocation = inferLocationFromPath();
    if (form.elements.location) {
      form.elements.location.value = inferredLocation || root.dataset.defaultLocation || "";
    }

    if (root.dataset.defaultProductType && form.elements.product_type) {
      form.elements.product_type.value = root.dataset.defaultProductType;
    }

    function updateOtherProduct() {
      var other = root.querySelector("[data-other-product]");
      var input = form.elements.product_type_other;
      var isOther = form.elements.product_type.value === "Other";
      if (other) {
        other.hidden = !isOther;
        other.style.display = isOther ? "" : "none";
      }
      if (input) input.required = false;
    }

    updateOtherProduct();
    form.elements.product_type.addEventListener("change", updateOtherProduct);

    form.elements.customer_phone.addEventListener("input", function (event) {
      event.target.value = formatPhone(event.target.value);
    });

    setupAddressAutocomplete(root, form);

    function deleteFile(path) {
      var file = files.find(function (item) { return item.path === path; });
      files = files.filter(function (item) { return item.path !== path; });
      renderFiles(root, files, deleteFile);

      if (!file || file.status === "uploading") return;

      fetch(proxyUrl(root, "/service-requests/uploads"), {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: file.path, draftId: draftId })
      }).catch(function () {});

      if (files.length === 0) {
        draftId = uuid();
        form.elements.draftId.value = draftId;
      }
    }

    form.elements.uploads.addEventListener("change", function (event) {
      var incoming = Array.prototype.slice.call(event.target.files || []);
      event.target.value = "";

      if (files.length + incoming.length > MAX_FILES) {
        setStatus(root, "You can upload up to " + MAX_FILES + " files.", "error");
        return;
      }

      incoming.forEach(function (file) {
        if (!isAllowedFile(file)) {
          setStatus(root, file.name + " is not an allowed file type.", "error");
          return;
        }

        if (file.size > MAX_FILE_SIZE) {
          setStatus(root, file.name + " exceeds the 50MB limit.", "error");
          return;
        }

        var tempPath = "local/" + uuid();
        files.push({
          path: tempPath,
          name: file.name,
          size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
          type: file.type,
          size_bytes: file.size,
          mime_type: file.type || null,
          status: "uploading"
        });
        renderFiles(root, files, deleteFile);

        var data = new FormData();
        data.append("file", file);
        data.append("draftId", draftId);

        fetch(proxyUrl(root, "/service-requests/uploads"), {
          method: "POST",
          body: data
        })
          .then(function (response) {
            return parseJsonResponse(response, "Failed to upload file").then(function (body) {
              return body.file;
            });
          })
          .then(function (uploaded) {
            files = files.map(function (item) {
              if (item.path !== tempPath) return item;
              return {
                path: uploaded.path,
                name: uploaded.name,
                size: uploaded.size,
                type: uploaded.type || file.type,
                size_bytes: uploaded.size_bytes || file.size,
                mime_type: uploaded.mime_type || file.type || null,
                status: "completed"
              };
            });
            setStatus(root, "", "success");
            renderFiles(root, files, deleteFile);
          })
          .catch(function (error) {
            files = files.filter(function (item) { return item.path !== tempPath; });
            setStatus(root, error.message || "Failed to upload file.", "error");
            renderFiles(root, files, deleteFile);
          });
      });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      setStatus(root, "", "success");
      clearResult(root);

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!formValue(form, "location")) {
        showResult(
          root,
          "error",
          "Service Request Not Submitted",
          "Please select a service location before submitting your request.",
          "Review and try again",
          function () { clearResult(root); }
        );
        return;
      }

      if (isDisallowedDate(formValue(form, "preferred_service_date"))) {
        showResult(
          root,
          "error",
          "Service Request Not Submitted",
          "Preferred Service Date must be a weekday after today.",
          "Review and try again",
          function () { clearResult(root); }
        );
        return;
      }

      if (files.some(function (file) { return file.status === "uploading"; })) {
        showResult(
          root,
          "error",
          "Service Request Not Submitted",
          "Please wait for uploads to finish before submitting your request.",
          "Review and try again",
          function () { clearResult(root); }
        );
        return;
      }

      var submit = form.querySelector("button[type='submit']");
      if (submit) {
        submit.disabled = true;
        submit.textContent = "Submitting...";
      }

      var completedFiles = files.filter(function (file) { return file.status === "completed"; });
      var payload = {
        formStartedAt: Number(form.elements.formStartedAt.value || Date.now()),
        honeypot: formValue(form, "company"),
        draftId: draftId,
        uploadPaths: completedFiles.map(function (file) { return file.path; }),
        uploadFiles: completedFiles.map(function (file) {
          return {
            path: file.path,
            original_name: file.name,
            size_bytes: file.size_bytes || 0,
            mime_type: file.mime_type || file.type || null
          };
        }),
        location: cleanText(formValue(form, "location")),
        customer_first_name: cleanText(formValue(form, "customer_first_name")),
        customer_last_name: cleanText(formValue(form, "customer_last_name")),
        customer_email: normalizeEmail(formValue(form, "customer_email")),
        customer_phone: formatPhone(formValue(form, "customer_phone")),
        customer_street_address: cleanText(formValue(form, "customer_street_address")),
        customer_city: cleanText(formValue(form, "customer_city")),
        customer_state: cleanText(formValue(form, "customer_state")),
        customer_zip: normalizeZip(formValue(form, "customer_zip")),
        product_type: cleanText(formValue(form, "product_type")),
        product_type_other: cleanText(formValue(form, "product_type_other")) || null,
        product_make: cleanText(formValue(form, "product_make")),
        product_model: cleanText(formValue(form, "product_model")),
        product_serial_number: cleanText(formValue(form, "product_serial_number")) || null,
        service_description: cleanMultiline(formValue(form, "service_description")),
        preferred_service_date: cleanText(formValue(form, "preferred_service_date")),
        preferred_time_window: cleanText(formValue(form, "preferred_time_window")),
        preferred_time_label: TIME_LABELS[formValue(form, "preferred_time_window")] || ""
      };

      fetch(proxyUrl(root, "/service-requests"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return parseJsonResponse(response, "Failed to submit service request");
        })
        .then(function () {
          form.reset();
          files = [];
          draftId = uuid();
          form.elements.draftId.value = draftId;
          form.elements.formStartedAt.value = String(Date.now());
          if (form.elements.location) {
            form.elements.location.value = inferredLocation || root.dataset.defaultLocation || "";
          }
          if (root.dataset.defaultProductType && form.elements.product_type) {
            form.elements.product_type.value = root.dataset.defaultProductType;
          }
          updateOtherProduct();
          renderFiles(root, files, deleteFile);
          showResult(
            root,
            "success",
            "Service Request Submitted",
            "A service manager will review your request and contact you soon.",
            "Submit another request",
            function () { clearResult(root); }
          );
        })
        .catch(function (error) {
          showResult(
            root,
            "error",
            "Service Request Not Submitted",
            error.message || "Something went wrong while submitting your service request. Please review the form and try again.",
            "Review and try again",
            function () { clearResult(root); }
          );
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = "Submit service request";
          }
        });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-lti-service-request]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();
